/* ============================================================
   HYPESOLE — interaction core
   Works standalone (prototype) and inside Shopify.
   Data source: window.HYPESOLE.products  |  Cart API: window.HYPESOLE.cartAdd
   ============================================================ */
(function () {
  'use strict';

  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const money = n => n.toLocaleString('en-US') + ' EGP';
  const RTL = document.documentElement.getAttribute('dir') === 'rtl';

  const CFG = window.HYPESOLE || (window.HYPESOLE = {});
  const PRODUCTS = CFG.products || [];
  const SIZES = [38, 39, 40, 41, 42, 43, 44, 45];

  /* ---------------------------------------------------------
     0. AMBIENT — preloader, cursor, progress, reveal
     --------------------------------------------------------- */
  window.addEventListener('load', () => {
    setTimeout(() => { const p = $('#preloader'); if (p) p.classList.add('done'); }, 1400);
  });

  const glow = $('#cursor-glow');
  if (glow) {
    let gx = innerWidth / 2, gy = innerHeight / 2, cx = gx, cy = gy;
    addEventListener('mousemove', e => { gx = e.clientX; gy = e.clientY; });
    (function loop() {
      cx += (gx - cx) * .09; cy += (gy - cy) * .09;
      glow.style.transform = `translate(${cx}px,${cy}px) translate(-50%,-50%)`;
      requestAnimationFrame(loop);
    })();
  }

  const bar = $('#scroll-progress');
  const nav = $('#nav');
  addEventListener('scroll', () => {
    const h = document.documentElement.scrollHeight - innerHeight;
    if (bar) bar.style.transform = 'scaleX(' + (h > 0 ? scrollY / h : 0) + ')';
    if (nav) nav.classList.toggle('stuck', scrollY > 40);
  }, { passive: true });

  const io = new IntersectionObserver(es => {
    es.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      const s = e.target.querySelector('.stock-bar i');
      if (s && s.dataset.w) s.style.width = s.dataset.w + '%';
      io.unobserve(e.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
  const observeReveals = root => $$('.rv', root || document).forEach(el => io.observe(el));

  /* spotlight-follow on drop cards */
  document.addEventListener('mousemove', e => {
    const c = e.target.closest && e.target.closest('.drop');
    if (!c) return;
    const r = c.getBoundingClientRect();
    c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    c.style.setProperty('--my', (e.clientY - r.top) + 'px');
  });

  /* ---------------------------------------------------------
     1. COUNTDOWNS  (data-deadline = epoch ms)
     --------------------------------------------------------- */
  /* Shopify sections pass an ISO date; convert it once to an epoch */
  $$('[data-deadline-iso]').forEach(el => {
    const t = Date.parse(el.dataset.deadlineIso);
    if (!isNaN(t)) el.dataset.deadline = t;
  });

  function tickAll() {
    const now = Date.now();
    $$('[data-deadline]').forEach(el => {
      let d = Math.max(0, +el.dataset.deadline - now);
      const day = Math.floor(d / 864e5); d -= day * 864e5;
      const hr  = Math.floor(d / 36e5);  d -= hr * 36e5;
      const mn  = Math.floor(d / 6e4);   d -= mn * 6e4;
      const sc  = Math.floor(d / 1e3);
      const p = n => String(n).padStart(2, '0');
      const set = (k, v) => { const t = el.querySelector('[data-u="' + k + '"]'); if (t) t.textContent = v; };
      set('d', p(day)); set('h', p(hr)); set('m', p(mn)); set('s', p(sc));
    });
    requestAnimationFrame(() => {});
  }
  setInterval(tickAll, 1000); tickAll();

  /* ---------------------------------------------------------
     2. SNEAKER RIG — clone SVG views, build pseudo-3D spinner
     --------------------------------------------------------- */
  function svgOf(id) {
    const t = document.getElementById(id);
    if (!t) return document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    return t.content.firstElementChild.cloneNode(true);
  }
  function paint(el, c) {
    if (!c) return el;
    el.style.setProperty('--c-up', c.up);
    el.style.setProperty('--c-ov', c.ov);
    el.style.setProperty('--c-mid', c.mid);
    el.style.setProperty('--c-out', c.out);
    el.style.setProperty('--c-acc', c.acc);
    el.style.setProperty('--c-lace', c.lace || c.out);
    return el;
  }
  const FACES = [
    { k: 0,   tpl: 'sk-lat',  cls: 'face--lat'  },
    { k: 90,  tpl: 'sk-heel', cls: 'face--heel' },
    { k: 180, tpl: 'sk-lat',  cls: 'face--med'  },
    { k: 270, tpl: 'sk-toe',  cls: 'face--toe'  }
  ];

  function createSpin(colors) {
    const wrap = document.createElement('div');
    wrap.className = 'spin';
    const box = document.createElement('div');
    box.className = 'spin-box';
    const faces = FACES.map(f => {
      const d = document.createElement('div');
      d.className = 'face ' + f.cls;
      d.dataset.k = f.k;
      d.appendChild(svgOf(f.tpl));
      box.appendChild(d);
      return d;
    });
    wrap.appendChild(box);
    const floor = document.createElement('div');
    floor.className = 'spin-floor';
    wrap.appendChild(floor);
    paint(wrap, colors);

    let angle = 0;
    function setAngle(a) {
      angle = ((a % 360) + 360) % 360;
      box.style.setProperty('--a', angle);
      /* same rule as the photo rig: whichever face is closest to the camera
         stays fully opaque, so the sneaker never thins out between anchors */
      let lead = 0, leadW = -1;
      const w = faces.map((fc, i) => {
        let d = Math.abs(angle - +fc.dataset.k) % 360;
        if (d > 180) d = 360 - d;
        const t = Math.cos(d * Math.PI / 180);
        const v = t <= 0 ? 0 : t;
        if (v > leadW) { leadW = v; lead = i; }
        return v;
      });
      faces.forEach((fc, i) => {
        let op;
        if (i === lead) op = 1;
        else if (leadW <= 0) op = 0;
        else op = Math.pow(w[i] / leadW, 4) * .8;
        fc.style.opacity = op.toFixed(3);
        fc.style.visibility = op < .01 ? 'hidden' : 'visible';
        fc.style.zIndex = i === lead ? 120 : Math.round(op * 100);
      });
    }
    setAngle(0);
    return { el: wrap, box, setAngle, get angle() { return angle; }, lateral: faces[0] };
  }
  /* ---------------------------------------------------------
     2b. AUTOMATIC WHITE-BACKGROUND REMOVAL

     A plain brightness threshold is wrong for footwear: it punches holes
     through a white midsole. So the fill is *seeded from the image border*
     and only travels through connected near-white pixels — anything white
     that is fenced in by the shoe stays.

     Shopify's CDN sends Access-Control-Allow-Origin, so the canvas can be
     read back. If a merchant serves images from somewhere that does not,
     getImageData throws and we quietly keep the original file; the CSS
     feather still hides the slab edge.
     --------------------------------------------------------- */
  const cutCache = new Map();

  function cutPixels(img, tol) {
    const MAXW = 1000;
    const scale = Math.min(1, MAXW / img.naturalWidth);
    const W = Math.max(1, Math.round(img.naturalWidth * scale));
    const H = Math.max(1, Math.round(img.naturalHeight * scale));
    const cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    const ctx = cv.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, W, H);
    const id = ctx.getImageData(0, 0, W, H); /* throws when tainted */
    const d = id.data;
    const N = W * H;

    /* near-white means bright AND unsaturated — a pale pink box would not
       qualify, which is what we want */
    const floor = 255 - tol;
    const near = p => {
      const i = p << 2, r = d[i], g = d[i + 1], b = d[i + 2];
      const mn = r < g ? (r < b ? r : b) : (g < b ? g : b);
      const mx = r > g ? (r > b ? r : b) : (g > b ? g : b);
      return mn >= floor && mx - mn <= 14;
    };

    const bg = new Uint8Array(N);
    const stack = new Int32Array(N);
    let sp = 0;
    for (let x = 0; x < W; x++) { stack[sp++] = x; stack[sp++] = (H - 1) * W + x; }
    for (let y = 0; y < H; y++) { stack[sp++] = y * W; stack[sp++] = y * W + W - 1; }
    let filled = 0;
    while (sp) {
      const p = stack[--sp];
      if (bg[p] || !near(p)) continue;
      bg[p] = 1; filled++;
      const x = p % W, y = (p - x) / W;
      if (x > 0) stack[sp++] = p - 1;
      if (x < W - 1) stack[sp++] = p + 1;
      if (y > 0) stack[sp++] = p - W;
      if (y < H - 1) stack[sp++] = p + W;
    }

    /* Nothing meaningful removed → the photo was not shot on white.
       Almost everything removed → the subject is white on white and we would
       be handing back an empty frame. Both cases keep the original. */
    const share = filled / N;
    if (share < 0.06 || share > 0.97) return null;

    /* erode one pixel so the pale fringe of the backdrop goes with it */
    const a = new Uint8Array(N);
    for (let p = 0; p < N; p++) {
      if (bg[p]) continue;
      const x = p % W, y = (p - x) / W;
      a[p] = ((x > 0 && bg[p - 1]) || (x < W - 1 && bg[p + 1]) ||
              (y > 0 && bg[p - W]) || (y < H - 1 && bg[p + W])) ? 0 : 255;
    }
    /* 3x3 box blur turns the hard cut into a soft edge */
    const soft = new Uint8Array(N);
    for (let y = 0; y < H; y++) {
      for (let x = 0; x < W; x++) {
        let s = 0, n = 0;
        for (let dy = -1; dy <= 1; dy++) {
          const yy = y + dy;
          if (yy < 0 || yy >= H) continue;
          for (let dx = -1; dx <= 1; dx++) {
            const xx = x + dx;
            if (xx < 0 || xx >= W) continue;
            s += a[yy * W + xx]; n++;
          }
        }
        soft[y * W + x] = s / n;
      }
    }

    for (let p = 0; p < N; p++) {
      const al = soft[p];
      const i = p << 2;
      if (!al) { d[i + 3] = 0; continue; }
      if (al < 250) {
        /* Edge pixels are the backdrop blended into the subject. Un-blending
           them against white removes the bright halo that otherwise outlines
           the cut-out on a dark section. */
        const f = al / 255, inv = 255 * (1 - f);
        d[i]     = clamp((d[i]     - inv) / f, 0, 255);
        d[i + 1] = clamp((d[i + 1] - inv) / f, 0, 255);
        d[i + 2] = clamp((d[i + 2] - inv) / f, 0, 255);
      }
      d[i + 3] = al;
    }
    ctx.putImageData(id, 0, 0);
    return cv.toDataURL('image/webp', 0.92) || cv.toDataURL('image/png');
  }

  function autoCutout(src, tol) {
    if (cutCache.has(src)) return cutCache.get(src);
    const job = new Promise(resolve => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        let out = null;
        try { out = cutPixels(img, tol || 32); } catch (e) { out = null; }
        resolve(out);
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });
    cutCache.set(src, job);
    return job;
  }

  /* Swap every image in a rig for its cut-out version once the work is done.
     Until then the rig shows the original, so nothing pops in late-loading. */
  function applyCutout(rig, tol) {
    const imgs = $$('img[data-osrc]', rig.el);
    if (!imgs.length) return;
    const srcs = [...new Set(imgs.map(i => i.dataset.osrc))];
    Promise.all(srcs.map(s => autoCutout(s, tol).then(out => [s, out]))).then(pairs => {
      const map = new Map(pairs);
      let any = false;
      imgs.forEach(im => {
        const out = map.get(im.dataset.osrc);
        if (out) { im.src = out; any = true; }
      });
      /* a real cut-out needs no CSS feather — that was only ever a stand-in */
      if (any) rig.el.classList.add('spin--cut-real');
    });
  }
  CFG.autoCutout = autoCutout;

  /* Photo turntable.

     Real photo sets are almost never a 24-frame turntable — a store usually has
     three or four studio shots. Cross-fading those reads as a slideshow, not a
     spin, so the photos are mounted on the same preserve-3d cylinder the SVG rig
     uses: each face sits at `rotateY(k) translateZ(R)` and the box counter-
     rotates, which means dragging actually orbits the shoe.

     A photo mirrored with rotateY(180deg) is a believable opposite side of a
     shoe, so a short set is filled out with mirrors rather than left with holes
     the camera can fall into. */
  /* There must always be a face pointing at the camera, at every angle.
     Three anchors leave a 60° gap and two leave a 90° one, and a face turned
     90° is edge-on — which is exactly how the product used to vanish
     mid-spin. So every short set is padded out to four anchors. */
  function photoFaces(images) {
    const n = images.length;
    if (n >= 4) return images.map((src, i) => ({ src, k: i * 360 / n, mirror: false }));
    if (n === 3) {
      return [
        { src: images[0], k: 0,   mirror: false },
        { src: images[1], k: 90,  mirror: false },
        { src: images[2], k: 180, mirror: false },
        { src: images[1], k: 270, mirror: true  }
      ];
    }
    if (n === 2) {
      return [
        { src: images[0], k: 0,   mirror: false },
        { src: images[1], k: 90,  mirror: false },
        { src: images[0], k: 180, mirror: true  },
        { src: images[1], k: 270, mirror: true  }
      ];
    }
    /* A single photo still has to cover all four quarters. The side views are
       the same shot squeezed on X — a shoe seen head-on really is that narrow,
       so it reads as the front and back rather than as a missing frame. */
    return [
      { src: images[0], k: 0,   mirror: false },
      { src: images[0], k: 90,  mirror: false, proxy: true },
      { src: images[0], k: 180, mirror: true  },
      { src: images[0], k: 270, mirror: true,  proxy: true }
    ];
  }

  function createPhotoSpin(images, opts) {
    const o = opts || {};
    const wrap = document.createElement('div');
    wrap.className = 'spin spin--photo' + (o.cutout === false ? '' : ' spin--cutout');
    const box = document.createElement('div');
    box.className = 'spin-box';

    const specs = photoFaces(images);
    /* Narrow faces (a shoe seen head-on) sit closer to the axis than the long
       side views, otherwise the shoe visibly grows as it turns. */
    const faces = specs.map((sp, i) => {
      const d = document.createElement('div');
      /* Head-on views sit further from the axis than the long side views, or
         the shoe visibly grows as it turns — that is geometry, so it applies
         to a proxy too. The narrow *frame* is only for a real head-on photo;
         a proxy keeps the full frame and is squeezed by its own transform. */
      const headOn = Math.abs(Math.cos(sp.k * Math.PI / 180)) < .35;
      d.className = 'photo-face' + (headOn && !sp.proxy ? ' photo-face--narrow' : '');
      d.dataset.k = sp.k;
      d.style.transform = 'translate(-50%,-50%) rotateY(' + sp.k + 'deg) translateZ(var(--r' + (headOn ? 'n' : '') + '))';
      const img = document.createElement('img');
      img.src = sp.src;
      img.dataset.osrc = sp.src;
      img.alt = '';
      img.decoding = 'async';
      img.draggable = false;
      if (i > 0) img.loading = 'lazy';
      /* A proxy side view is the same photo foreshortened on X; a real one is
         only mirrored. */
      const sx = (sp.proxy ? .42 : 1) * (sp.mirror ? -1 : 1);
      if (sx !== 1) img.style.transform = 'scaleX(' + sx + ')';
      d.appendChild(img);
      box.appendChild(d);
      return d;
    });

    wrap.appendChild(box);
    const floor = document.createElement('div');
    floor.className = 'spin-floor';
    wrap.appendChild(floor);

    let angle = 0;
    function setAngle(a) {
      angle = ((a % 360) + 360) % 360;
      box.style.setProperty('--a', angle);

      /* The old curve gave every face pow(cos Δ, 1.5), so halfway between two
         anchors both sat at ~0.59 and the product visibly thinned out — at a
         quarter it could disappear outright. Now the face closest to the
         camera is pinned at full opacity whatever the angle, and its
         neighbour ghosts in behind it. The product is never see-through. */
      let lead = 0, leadW = -1;
      const w = faces.map((fc, i) => {
        let d = Math.abs(angle - +fc.dataset.k) % 360;
        if (d > 180) d = 360 - d;
        const t = Math.cos(d * Math.PI / 180);
        const v = t <= 0 ? 0 : t;
        if (v > leadW) { leadW = v; lead = i; }
        return v;
      });
      faces.forEach((fc, i) => {
        let op;
        if (i === lead) op = 1;
        else if (leadW <= 0) op = 0;
        else op = Math.pow(w[i] / leadW, 4) * .8;
        fc.style.opacity = op.toFixed(3);
        fc.style.visibility = op < .01 ? 'hidden' : 'visible';
        fc.style.zIndex = i === lead ? 120 : Math.round(op * 100);
      });
    }
    setAngle(0);
    return {
      el: wrap, box, setAngle,
      get angle() { return angle; },
      lateral: faces[0],
      isPhoto: true
    };
  }

  /* Extruded relief.

     A photo is flat, so there is no honest way to turn one into a real 3D
     model in the browser. What does hold up is giving the cut-out silhouette
     thickness: the same image is stacked along Z a few dozen times, the inner
     copies darkened, and the stack rotates as one solid. Edge-on you see the
     side wall, so it reads as a carved object rather than a picture — and
     unlike a turntable it can be tumbled on both axes.

     This only works once the background is gone; on an uncut photo the stack
     is just a white brick, so the caller always pairs it with the cut-out. */
  function createExtrudeSpin(src, opts) {
    const o = opts || {};
    const layers = Math.max(6, Math.min(40, o.layers || 22));
    const depth = o.depth || 46;

    const wrap = document.createElement('div');
    wrap.className = 'spin spin--photo spin--extrude' + (o.cutout === false ? '' : ' spin--cutout');
    const box = document.createElement('div');
    box.className = 'spin-box';

    for (let i = 0; i < layers; i++) {
      const t = layers === 1 ? .5 : i / (layers - 1);      /* 0 = back, 1 = front */
      const l = document.createElement('div');
      l.className = 'ex-layer';
      l.style.transform = 'translate(-50%,-50%) translateZ(' + ((t - .5) * depth).toFixed(2) + 'px)';
      const img = document.createElement('img');
      img.src = src;
      img.dataset.osrc = src;
      img.alt = '';
      img.decoding = 'async';
      img.draggable = false;
      /* bright at both faces, dark through the middle, so the wall reads as
         shadowed material from whichever side you are looking */
      const edge = Math.abs(t - .5) * 2;
      const bright = 'brightness(' + (.42 + .58 * edge).toFixed(3) + ')';
      /* one shadow, on the frontmost copy — one per layer stacks into mud */
      img.style.filter = i === layers - 1
        ? 'drop-shadow(0 20px 26px rgba(10,10,12,.26)) ' + bright
        : bright;
      l.appendChild(img);
      box.appendChild(l);
    }

    wrap.appendChild(box);
    const floor = document.createElement('div');
    floor.className = 'spin-floor';
    wrap.appendChild(floor);

    let angle = 0, tilt = 0;
    const setAngle = a => {
      angle = ((a % 360) + 360) % 360;
      box.style.setProperty('--a', angle);
    };
    const setTilt = x => {
      tilt = clamp(x, -70, 70);
      box.style.setProperty('--x', tilt);
    };
    setAngle(0); setTilt(0);
    return {
      el: wrap, box, setAngle, setTilt,
      get angle() { return angle; },
      get tilt() { return tilt; },
      lateral: box.lastChild,
      isPhoto: true,
      isExtrude: true
    };
  }

  /* Picks the right rig: real photos when they exist, SVG art otherwise. */
  function makeRig(data) {
    const imgs = (data && data.images) || [];
    if (!imgs.length) return createSpin(data && data.colors);
    const cutout = data.cutout !== undefined ? data.cutout : CFG.cutWhiteBg !== false;
    const rig = data.mode === 'extrude'
      ? createExtrudeSpin(imgs[0], { cutout: cutout, depth: data.depth, layers: data.layers })
      : createPhotoSpin(imgs, { cutout: cutout });
    /* The extruded stack is unreadable until the backdrop is gone, so it opts
       in regardless of the store-wide preference. */
    if (cutout || rig.isExtrude) applyCutout(rig, data.tolerance);
    return rig;
  }

  CFG.createSpin = createSpin;
  CFG.createPhotoSpin = createPhotoSpin;
  CFG.svgOf = svgOf;
  CFG.paint = paint;

  const easeInOut = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  function animateAngle(rig, from, to, dur, done) {
    const t0 = performance.now();
    (function step(now) {
      const p = clamp((now - t0) / dur, 0, 1);
      rig.setAngle(from + (to - from) * easeInOut(p));
      if (p < 1) requestAnimationFrame(step); else done && done();
    })(t0);
  }
  /* Turntable driver.

     Two separate things made the old rotation feel wrong. It eased across the
     whole 360, and an ease-in-out is *fastest in the middle* — so the shoe
     crawled at the side view and bolted through the toe and heel. And it
     advanced a fixed amount per frame, so the speed depended on the monitor:
     a 120 Hz screen span twice as fast as a 60 Hz one.

     This one is driven by elapsed time and walks anchor to anchor, easing
     gently into each face and resting there before moving on, so a customer
     actually gets a look at the front, the back and both sides. */
  function orbit(rig, opts) {
    const o = opts || {};
    const anchors = Math.max(1, o.anchors || 4);
    const revMs = Math.max(2000, (o.seconds || 20) * 1000);
    const dwellMs = Math.max(0, (o.dwell || 0) * 1000);
    /* whatever is left of the revolution after the rests is the travel time */
    const stepMs = Math.max(280, (revMs - anchors * dwellMs) / anchors);
    const stepDeg = 360 / anchors;
    const tiltAmp = o.tilt || 0;
    const tiltMs = (o.tiltSeconds || 9) * 1000;
    /* a sine ease over one 90° hop is gentle — it settles onto a face without
       the mid-revolution sprint a cubic ease over the full turn produced */
    const easeSine = t => .5 - Math.cos(Math.PI * t) / 2;

    let dir = 1, base = rig.angle, moving = true, paused = false;
    let phase = performance.now(), t0 = phase, raf = 0;

    function frame(now) {
      raf = requestAnimationFrame(frame);
      if (paused) { phase = now; t0 = now; return; }
      if (tiltAmp && rig.setTilt) rig.setTilt(Math.sin((now - t0) / tiltMs * Math.PI * 2) * tiltAmp);
      const el = now - phase;
      if (moving) {
        const p = clamp(el / stepMs, 0, 1);
        rig.setAngle(base + dir * stepDeg * easeSine(p));
        if (p >= 1) {
          base += dir * stepDeg;
          rig.setAngle(base);
          phase = now;
          if (dwellMs > 0) moving = false;
        }
      } else if (el >= dwellMs) {
        phase = now;
        moving = true;
      }
      if (o.onFrame) o.onFrame();
    }
    raf = requestAnimationFrame(frame);

    return {
      pause() { paused = true; },
      resume() { paused = false; phase = performance.now(); },
      reverse() { dir = -dir; base = rig.angle; phase = performance.now(); moving = true; },
      /* pick the cycle back up from wherever a drag left the product */
      sync() { base = rig.angle; phase = performance.now(); moving = true; },
      stop() { cancelAnimationFrame(raf); },
      get paused() { return paused; },
      revMs: revMs
    };
  }

  /* pitch, for rigs that have a second axis */
  function animateTilt(rig, from, to, dur, done) {
    if (!rig.setTilt) return done && done();
    const t0 = performance.now();
    (function step(now) {
      const p = clamp((now - t0) / dur, 0, 1);
      rig.setTilt(from + (to - from) * easeInOut(p));
      if (p < 1) requestAnimationFrame(step); else done && done();
    })(t0);
  }

  /* ---------------------------------------------------------
     3. CINEMATIC HERO DIRECTOR
        enter → explode (detail from every side) → reassemble
        → full 360 sweep → next slide
     --------------------------------------------------------- */
  const XPARTS = [
    { cls: 'p--lace',   x: 44, y: 4,  t: 'PRIMEKNIT LACE',  s: 'Anti-slip reinforced lacing' },
    { cls: 'p--collar', x: 71, y: 15, t: 'PADDED COLLAR',   s: 'Memory-foam ankle padding' },
    { cls: 'p--heel',   x: 86, y: 42, t: 'HEEL COUNTER',    s: 'TPU external heel support' },
    { cls: 'p--panel',  x: 17, y: 26, t: 'SIDE PANEL',      s: 'Full-grain tanned leather' },
    { cls: 'p--mid',    x: 8,  y: 63, t: 'AIR MIDSOLE',     s: 'Visible air cushioning unit' },
    { cls: 'p--out',    x: 34, y: 90, t: 'RUBBER OUTSOLE',  s: 'High-abrasion rubber compound' }
  ];

  function initHero() {
    const stage = $('#hero-stage');
    if (!stage) return;
    const slides = CFG.heroSlides || [];
    if (!slides.length) return;

    const tilt = document.createElement('div');
    tilt.className = 'stage-tilt';
    stage.appendChild(tilt);

    const labelBox = document.createElement('div');
    labelBox.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:6';
    stage.appendChild(labelBox);
    const labels = XPARTS.map(p => {
      const d = document.createElement('div');
      d.className = 'x-label';
      d.style.left = p.x + '%'; d.style.top = p.y + '%';
      d.innerHTML = '<i></i><b>' + p.t + '</b><u>' + p.s + '</u>';
      labelBox.appendChild(d);
      return d;
    });

    const rigs = slides.map((s, i) => {
      const holder = document.createElement('div');
      holder.className = 'hero-slide' + (i === 0 ? ' on' : '');
      const fl = document.createElement('div');
      fl.className = 'float';
      const rig = makeRig(s);
      fl.appendChild(rig.el);
      holder.appendChild(fl);
      const sh = document.createElement('div');
      sh.className = 'stage-shadow';
      holder.appendChild(sh);
      tilt.appendChild(holder);
      return { holder, rig, data: s };
    });

    const copies = $$('.hero-copy');
    const dotsBox = $('#hero-dots');
    const dots = slides.map((s, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', () => go(i, true));
      dotsBox && dotsBox.appendChild(b);
      return b;
    });
    const phaseEl = $('#hero-phase-txt');
    const setPhase = t => { if (phaseEl) phaseEl.textContent = t; };

    /* Pacing comes from the section settings. A slide has to outlast a whole
       revolution or the hero cuts away before the product has come back round
       to the front. */
    const SPIN = CFG.heroSpin || {};
    const SPIN_SEC = SPIN.seconds || 20;
    const SPIN_DWELL = SPIN.dwell === undefined ? 1.5 : SPIN.dwell;
    let cur = -1, timers = [], DUR = Math.max(11200, SPIN_SEC * 1000 + 1800);
    const clear = () => { timers.forEach(clearTimeout); timers = []; };
    const at = (ms, fn) => timers.push(setTimeout(fn, ms));

    function go(i, manual) {
      if (i === cur) return;
      clear();
      const prev = cur; cur = i;
      /* a slide can be left mid-explode when the timeline is cut short */
      labels.forEach(l => l.classList.remove('on'));
      rigs.forEach((r, k) => {
        r.holder.classList.toggle('on', k === i);
        r.holder.classList.toggle('out', k === prev);
        if (r.orbit) { r.orbit.stop(); r.orbit = null; }
        if (k !== i) {
          r.holder.classList.remove('exploded');
          r.rig.lateral.classList.remove('exploded');
          r.rig.setAngle(0);
        }
      });
      copies.forEach((c, k) => c.classList.toggle('on', k === i));
      dots.forEach((d, k) => { d.classList.remove('on'); if (k === i) { void d.offsetWidth; d.classList.add('on'); } });
      document.documentElement.style.setProperty('--slide-dur', DUR + 'ms');
      run(rigs[i]);
    }

    function run(slide) {
      const rig = slide.rig;
      setPhase('TRACKING SHOT');

      /* Both photo modes now hand the rotation to the same steady driver. The
         relief also gets a slow pitch so its top and underside come round. */
      if (rig.isPhoto) {
        setPhase(rig.isExtrude ? 'SOLIDIFYING' : 'TRACKING SHOT');
        at(900, () => {
          setPhase('360° ORBIT');
          slide.orbit = orbit(rig, {
            anchors: 4,
            seconds: SPIN_SEC,
            dwell: SPIN_DWELL,
            tilt: rig.isExtrude ? 13 : 0,
            tiltSeconds: SPIN_SEC
          });
        });
        at(DUR - 400, () => setPhase('NEXT DROP'));
        at(DUR, () => go((cur + 1) % rigs.length));
        return;
      }

      at(1500, () => {                       // ---- exploded detail pass
        setPhase('EXPLODED VIEW');
        rig.lateral.classList.add('exploded');
        labels.forEach((l, k) => at(k * 110, () => l.classList.add('on')));
      });
      at(5200, () => {                       // ---- reassemble
        setPhase('RE-ASSEMBLY');
        labels.forEach(l => l.classList.remove('on'));
        rig.lateral.classList.remove('exploded');
      });
      at(6700, () => {                       // ---- full 360 sweep
        setPhase('360° ORBIT');
        slide.orbit = orbit(rig, { anchors: 4, seconds: SPIN_SEC, dwell: SPIN_DWELL });
      });
      at(DUR - 400, () => setPhase('NEXT DROP'));
      at(DUR, () => go((cur + 1) % rigs.length));
    }

    /* ---- grab and turn it yourself -------------------------------------
       The hero used to be look-only. Dragging now takes the product over,
       freezes the auto-orbit and the slide advance, and hands control back a
       few seconds after you let go — from wherever you left it, not from 0. */
    let dragging = false, lastX = 0, lastY = 0, wasTouch = false, resumeT = 0;
    const curSlide = () => rigs[cur];

    function dragStart(e) {
      const s = curSlide();
      if (!s) return;
      dragging = true; wasTouch = !!e.touches;
      const p = e.touches ? e.touches[0] : e;
      lastX = p.clientX; lastY = p.clientY;
      stage.classList.add('is-grabbing');
      clearTimeout(resumeT);
      clear();                                  /* hold this slide */
      if (s.orbit) s.orbit.pause();
      setPhase('YOUR TURN');
    }
    function dragMove(e) {
      if (!dragging) return;
      const s = curSlide(); if (!s) return;
      const p = e.touches ? e.touches[0] : e;
      s.rig.setAngle(s.rig.angle + (lastX - p.clientX) * .5);
      /* vertical drag is the page's on touch — only a mouse gets the pitch */
      if (!wasTouch && s.rig.setTilt) s.rig.setTilt(s.rig.tilt - (lastY - p.clientY) * .3);
      lastX = p.clientX; lastY = p.clientY;
    }
    function dragEnd() {
      if (!dragging) return;
      dragging = false;
      stage.classList.remove('is-grabbing');
      const s = curSlide(); if (!s) return;
      resumeT = setTimeout(() => {
        setPhase('360° ORBIT');
        if (s.orbit) { s.orbit.sync(); s.orbit.resume(); }
        else s.orbit = orbit(s.rig, { anchors: 4, seconds: SPIN_SEC, dwell: SPIN_DWELL });
        at(DUR, () => go((cur + 1) % rigs.length));
      }, 2800);
    }

    stage.addEventListener('mousedown', dragStart);
    addEventListener('mousemove', dragMove);
    addEventListener('mouseup', dragEnd);
    stage.addEventListener('touchstart', dragStart, { passive: true });
    stage.addEventListener('touchmove', dragMove, { passive: true });
    addEventListener('touchend', dragEnd);

    /* cursor 3D tilt — suppressed mid-drag, or the parallax fights the turn */
    if (matchMedia('(hover:hover)').matches) {
      stage.addEventListener('mousemove', e => {
        if (dragging) return;
        const r = stage.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - .5;
        const py = (e.clientY - r.top) / r.height - .5;
        tilt.style.transform = `perspective(1400px) rotateY(${px * 17}deg) rotateX(${-py * 13}deg) translateZ(26px)`;
      });
      stage.addEventListener('mouseleave', () => { if (!dragging) tilt.style.transform = ''; });
    }
    go(0);
  }

  /* ---------------------------------------------------------
     4. PRODUCT CARDS  (internal angle slider + dual checkout)
     --------------------------------------------------------- */
  const ANGLES = [
    { tpl: 'sk-lat',  n: 'Lateral' },
    { tpl: 'sk-toe',  n: 'Front' },
    { tpl: 'sk-sole', n: 'Outsole' },
    { tpl: 'sk-top',  n: 'Top'  }
  ];
  const starsHTML = r => {
    let h = '';
    for (let i = 1; i <= 5; i++) h += '<i class="fa-solid fa-star' + (r >= i ? '' : (r >= i - .5 ? '-half-stroke' : ' fa-regular')) + '"></i>';
    return h;
  };

  function buildCard(p) {
    const off = p.compare ? Math.round((1 - p.price / p.compare) * 100) : 0;
    const card = document.createElement('article');
    card.className = 'card rv';
    card.dataset.id = p.id;
    card.innerHTML =
      '<div class="card-media">' +
        '<div class="card-tags">' +
          (p.tab === 'new' ? '<span class="tag tag--new">NEW IN</span>' : '<span class="tag tag--hot">HYPE DROP</span>') +
          (off ? '<span class="tag tag--off">-' + off + '% OFF</span>' : '') +
        '</div>' +
        '<button class="card-fav" type="button" aria-label="Add to wishlist"><i class="fa-regular fa-heart"></i></button>' +
        '<div class="card-track"></div>' +
        '<button class="card-nav card-nav--prev" type="button" aria-label="Previous angle"><i class="fa-solid fa-chevron-right"></i></button>' +
        '<button class="card-nav card-nav--next" type="button" aria-label="Next angle"><i class="fa-solid fa-chevron-left"></i></button>' +
        '<span class="card-angle">LATERAL</span>' +
        '<div class="card-dots"></div>' +
        '<button class="qv-btn" type="button"><i class="fa-solid fa-expand"></i> Quick View</button>' +
      '</div>' +
      '<div class="card-body">' +
        '<div class="card-brand ltr">' + p.brand + '</div>' +
        '<h3 class="card-title">' + p.name + '</h3>' +
        '<div class="rating"><span class="stars">' + starsHTML(p.rating) + '</span>' +
          '<b class="ltr">' + p.rating.toFixed(1) + '/5.0</b><span>' + p.reviews + ' reviews</span></div>' +
        '<div class="card-foot">' +
          '<div class="price"><b>' + money(p.price) + '</b>' + (p.compare ? '<s>' + money(p.compare) + '</s>' : '') + '</div>' +
          '<div class="sizes-mini ltr">' + p.sizes.slice(0, 3).map(s => '<span>' + s + '</span>').join('') + '<span>+</span></div>' +
        '</div>' +
        '<div class="viewers"><i class="fa-solid fa-circle"></i><span>' + (18 + Math.floor(Math.random() * 40)) + ' people are viewing this right now</span></div>' +
        '<div class="card-actions">' +
          '<button class="btn btn-sm btn-atc" type="button"><i class="fa-solid fa-bag-shopping"></i> Add to Cart</button>' +
          '<button class="btn btn-sm btn-buy" type="button"><i class="fa-solid fa-bolt"></i> Buy Now</button>' +
        '</div>' +
      '</div>';

    const track = $('.card-track', card);
    const dotsW = $('.card-dots', card);
    const angleTxt = $('.card-angle', card);
    ANGLES.forEach((a, i) => {
      const cell = document.createElement('div');
      cell.className = 'card-cell';
      cell.appendChild(paint(svgOf(a.tpl), p.colors));
      track.appendChild(cell);
      const d = document.createElement('button');
      d.type = 'button';
      d.className = i === 0 ? 'on' : '';
      d.setAttribute('aria-label', a.n);
      d.addEventListener('click', e => { e.stopPropagation(); slide(i); });
      dotsW.appendChild(d);
    });
    let idx = 0;
    function slide(i) {
      idx = (i + ANGLES.length) % ANGLES.length;
      track.style.transform = 'translateX(' + (RTL ? '' : '-') + (idx * 100) + '%)';
      $$('button', dotsW).forEach((d, k) => d.classList.toggle('on', k === idx));
      angleTxt.textContent = ANGLES[idx].n;
    }
    $('.card-nav--next', card).addEventListener('click', e => { e.stopPropagation(); slide(idx + 1); });
    $('.card-nav--prev', card).addEventListener('click', e => { e.stopPropagation(); slide(idx - 1); });

    $('.card-fav', card).addEventListener('click', function (e) {
      e.stopPropagation();
      this.classList.toggle('on');
      const on = this.classList.contains('on');
      this.innerHTML = '<i class="fa-' + (on ? 'solid' : 'regular') + ' fa-heart"></i>';
      toast(on ? 'Added to wishlist' : 'Removed from wishlist', p.name, on ? 'fa-heart' : 'fa-heart-crack');
    });
    $('.qv-btn', card).addEventListener('click', () => openQuick(p));
    $('.btn-atc', card).addEventListener('click', function () {
      this.classList.remove('bump'); void this.offsetWidth; this.classList.add('bump');
      addToCart(p, p.sizes[1] || p.sizes[0]);
    });
    $('.btn-buy', card).addEventListener('click', () => buyNow(p, p.sizes[1] || p.sizes[0]));
    return card;
  }

  /* ---------------------------------------------------------
     5. THE 2-TAB MENU → filtered grid
     --------------------------------------------------------- */
  function initTabs() {
    const tabsBox = $('#tabs');
    const panel = $('#grid-panel');
    if (!tabsBox || !panel) return;
    const pill = $('.pill', tabsBox);
    const tabs = $$('.tab', tabsBox);

    function movePill(btn, retry) {
      if (!pill || !btn) return;
      const w = btn.offsetWidth;
      /* the drawer may not be laid out on first paint — retry once next frame */
      if (!w && !retry) { requestAnimationFrame(() => movePill(btn, true)); return; }
      pill.style.width = w + 'px';
      const off = RTL
        ? tabsBox.offsetWidth - btn.offsetLeft - w
        : btn.offsetLeft;
      pill.style.transform = 'translateX(' + (RTL ? '-' : '') + (off - 5) + 'px)';
      pill.style.insetInlineStart = '5px';
    }
    const syncPill = () => movePill($('.tab[aria-selected="true"]', tabsBox) || tabs[0]);

    /* Shopify mode: panes are already rendered by Liquid — just cross-fade them */
    const panes = $$('.tab-pane', panel);

    function render(key) {
      panel.classList.add('fade');

      if (panes.length) {
        setTimeout(() => {
          panes.forEach(p => { p.hidden = p.dataset.pane !== key; });
          observeReveals(panel);
          requestAnimationFrame(() => $$('.rv', panel).forEach(e => e.classList.add('in')));
          panel.classList.remove('fade');
        }, 300);
        return;
      }

      setTimeout(() => {
        panel.innerHTML = '';
        const grid = document.createElement('div');
        grid.className = 'grid';
        PRODUCTS.filter(p => p.tab === key).forEach((p, i) => {
          const c = buildCard(p);
          c.classList.add('rv-d' + ((i % 4) + 1));
          grid.appendChild(c);
        });
        panel.appendChild(grid);
        observeReveals(panel);
        requestAnimationFrame(() => $$('.rv', panel).forEach(e => e.classList.add('in')));
        panel.classList.remove('fade');
      }, 300);
    }

    tabs.forEach(t => t.addEventListener('click', () => {
      tabs.forEach(x => x.setAttribute('aria-selected', String(x === t)));
      movePill(t);
      render(t.dataset.tab);
      const shop = $('#shop');
      if (shop && shop.getBoundingClientRect().top < -60) shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    const active = tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
    requestAnimationFrame(syncPill);
    addEventListener('load', syncPill);
    addEventListener('resize', syncPill);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncPill);
    const burgerBtn = $('#burger');
    if (burgerBtn) burgerBtn.addEventListener('click', () => setTimeout(syncPill, 60));
    render(active.dataset.tab);
  }

  /* In-section tab bar. Every [data-ptabs] wires itself, so a page can carry
     several tab sections and each keeps its own state. */
  function initProductTabs() {
    $$('[data-ptabs]').forEach(root => {
      const bar = $('.ptabs-bar', root);
      const panel = $('.grid-panel', root);
      if (!bar || !panel) return;
      const pill = $('.ptabs-pill', bar);
      const tabs = $$('.ptab', bar);
      const panes = $$('.tab-pane', panel);
      if (!tabs.length) return;

      function movePill(btn, retry) {
        if (!pill || !btn) return;
        const w = btn.offsetWidth;
        if (!w && !retry) { requestAnimationFrame(() => movePill(btn, true)); return; }
        pill.style.width = w + 'px';
        const off = btn.offsetLeft - bar.scrollLeft - 5;
        pill.style.transform = 'translateX(' + (RTL ? -off : off) + 'px)';
      }
      const syncPill = () => movePill(tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0]);

      function show(key) {
        panel.classList.add('fade');
        setTimeout(() => {
          panes.forEach(p => { p.hidden = p.dataset.pane !== key; });
          observeReveals(panel);
          requestAnimationFrame(() => $$('.rv', panel).forEach(e => e.classList.add('in')));
          panel.classList.remove('fade');
        }, 260);
      }

      tabs.forEach(t => t.addEventListener('click', () => {
        if (t.getAttribute('aria-selected') === 'true') return;
        tabs.forEach(x => x.setAttribute('aria-selected', String(x === t)));
        t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        movePill(t);
        show(t.dataset.pane);
      }));

      bar.addEventListener('scroll', syncPill, { passive: true });
      addEventListener('resize', syncPill);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncPill);
      requestAnimationFrame(syncPill);
    });
  }

  /* ---------------------------------------------------------
     6. QUICK VIEW (blur pop-up + zoom + size picker)
     --------------------------------------------------------- */
  let qvState = { p: null, size: null, view: 0 };
  function openQuick(p) {
    const sheet = $('#quickview');
    if (!sheet) return;
    qvState = { p: p, size: null, view: 0 };
    $('#qv-brand').textContent = p.brand;
    $('#qv-title').textContent = p.name;
    $('#qv-desc').textContent = p.desc;
    $('#qv-stars').innerHTML = starsHTML(p.rating);
    $('#qv-rate').textContent = p.rating.toFixed(1) + '/5.0';
    $('#qv-reviews').textContent = p.reviews + ' verified reviews';
    $('#qv-price').innerHTML = '<b>' + money(p.price) + '</b>' + (p.compare ? '<s>' + money(p.compare) + '</s>' : '');
    $('#qv-specs').innerHTML = p.specs.map(s =>
      '<div><b>' + s[1] + '</b><span>' + s[0] + '</span></div>').join('');

    const sizeBox = $('#qv-sizes'); sizeBox.innerHTML = '';
    SIZES.forEach(s => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'size'; b.textContent = s;
      if (p.sizes.indexOf(s) === -1) b.disabled = true;
      b.addEventListener('click', () => {
        $$('.size', sizeBox).forEach(x => x.classList.remove('on'));
        b.classList.add('on'); qvState.size = s;
      });
      sizeBox.appendChild(b);
    });

    const zoom = $('#qv-zoom'), thumbs = $('#qv-thumbs');
    zoom.classList.remove('zoomed');
    thumbs.innerHTML = '';
    function show(i) {
      qvState.view = i;
      zoom.innerHTML = '';
      zoom.appendChild(paint(svgOf(ANGLES[i].tpl), p.colors));
      $$('button', thumbs).forEach((b, k) => b.classList.toggle('on', k === i));
    }
    ANGLES.forEach((a, i) => {
      const b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', a.n);
      b.appendChild(paint(svgOf(a.tpl), p.colors));
      b.addEventListener('click', () => show(i));
      thumbs.appendChild(b);
    });
    show(0);

    sheet.classList.add('on');
    document.body.classList.add('is-locked');
  }
  function closeQuick() {
    const s = $('#quickview'); if (!s) return;
    s.classList.remove('on'); document.body.classList.remove('is-locked');
  }

  /* ---------------------------------------------------------
     7. CART — simulated AJAX + drawer
     --------------------------------------------------------- */
  const CART = [];
  const FREE_SHIP = 3000;

  function addToCart(p, size, silent) {
    const line = CART.find(l => l.id === p.id && l.size === size);
    if (line) line.qty++; else CART.push({ id: p.id, size: size, qty: 1, p: p });
    renderCart();
    const c = $('#cart-count');
    if (c) { c.classList.remove('pop'); void c.offsetWidth; c.classList.add('pop'); }
    if (!silent) toast('Added to cart', p.name + '  ·  EU ' + size, 'fa-bag-shopping');
    /* Shopify hook: replace with fetch('/cart/add.js', …) */
    if (typeof CFG.cartAdd === 'function') CFG.cartAdd(p, size);
  }
  function renderCart() {
    const body = $('#cart-body'); if (!body) return;
    const count = CART.reduce((n, l) => n + l.qty, 0);
    const total = CART.reduce((n, l) => n + l.qty * l.p.price, 0);
    const cc = $('#cart-count'); if (cc) cc.textContent = count;
    $('#cart-sub').textContent = money(total);
    $('#cart-total').textContent = money(total);
    const pct = clamp(total / FREE_SHIP * 100, 0, 100);
    $('#ship-bar').style.width = pct + '%';
    $('#ship-txt').innerHTML = total >= FREE_SHIP
      ? '<i class="fa-solid fa-truck-fast"></i> Nice! You unlocked free express shipping'
      : 'Add <b>' + money(FREE_SHIP - total) + '</b> more for free express shipping';
    if (!CART.length) {
      body.innerHTML = '<div class="cart-empty"><i class="fa-solid fa-bag-shopping"></i>Your cart is empty — start with the hottest drop</div>';
      return;
    }
    body.innerHTML = '';
    CART.forEach((l, i) => {
      const d = document.createElement('div');
      d.className = 'citem';
      d.innerHTML = '<div class="citem-media"></div><div><b>' + l.p.name + '</b>' +
        '<small class="ltr">' + l.p.brand + '  ·  EU ' + l.size + '  ·  x' + l.qty + '</small>' +
        '<div class="pz">' + money(l.p.price * l.qty) + '</div></div>' +
        '<button class="rm" type="button" aria-label="Remove"><i class="fa-solid fa-xmark"></i></button>';
      $('.citem-media', d).appendChild(paint(svgOf('sk-lat'), l.p.colors));
      $('.rm', d).addEventListener('click', () => { CART.splice(i, 1); renderCart(); });
      body.appendChild(d);
    });
  }
  const openCart = () => { $('#cart').classList.add('on'); $('#cart-bg').classList.add('on'); document.body.classList.add('is-locked'); };
  const closeCart = () => { $('#cart').classList.remove('on'); $('#cart-bg').classList.remove('on'); document.body.classList.remove('is-locked'); };

  /* ---------------------------------------------------------
     8. BUY NOW — bypasses the cart, simulates /checkout
     --------------------------------------------------------- */
  function buyNow(p, size) {
    const ov = $('#checkout-ov'); if (!ov) return;
    $('#co-item').textContent = p.name + '  ·  EU ' + size + '  ·  ' + money(p.price);
    ov.classList.add('on'); document.body.classList.add('is-locked');
    const bar2 = $('#co-bar'); bar2.style.animation = 'none'; void bar2.offsetWidth; bar2.style.animation = '';
    setTimeout(() => {
      ov.classList.remove('on'); document.body.classList.remove('is-locked');
      toast('Express checkout simulated', 'On a live store this redirects to /checkout', 'fa-lock');
      /* Shopify: window.location.href = '/cart/' + variantId + ':1?checkout' */
    }, 2600);
  }

  /* ---------------------------------------------------------
     9. TOASTS
     --------------------------------------------------------- */
  function toast(title, sub, icon) {
    const zone = $('#toast-zone'); if (!zone) return;
    const t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = '<i class="fa-solid ' + (icon || 'fa-circle-check') + '"></i><div><b>' + title + '</b><small>' + (sub || '') + '</small></div>';
    zone.appendChild(t);
    setTimeout(() => { t.classList.add('out'); setTimeout(() => t.remove(), 400); }, 3000);
  }
  CFG.toast = toast;

  /* ---------------------------------------------------------
     10. 360° INTERACTIVE VIEWER
     --------------------------------------------------------- */
  function init360() {
    const stage = $('#spin360'); if (!stage) return;
    const set = CFG.spinProduct;
    if (!set) return;
    const colorways = set.colorways || [];

    /* The selected product's photos win; the SVG rig is the fallback. */
    const rig = makeRig({
      images: set.images, mode: set.mode, cutout: set.cutout,
      tolerance: set.tolerance, colors: (colorways[0] || {}).colors
    });
    stage.insertBefore(rig.el, stage.firstChild);

    /* Colourway swatches only mean something for the SVG art. */
    const swatchWrap = $('#spin-swatches');
    if (rig.isPhoto) {
      if (swatchWrap) swatchWrap.style.display = 'none';
      const cwName = $('#spin-cw-name');
      const cwRow = cwName && cwName.closest('.field-label');
      if (cwRow) cwRow.style.display = 'none';
    }

    const deg = $('#spin-deg');
    let drag = false, lastX = 0, colorIdx = 0;
    function upd() { if (deg) deg.textContent = Math.round(rig.angle) + '°'; }

    /* Same steady driver as the hero: paced in seconds, resting on each face,
       instead of a fixed step per frame that ran at the monitor's mercy. */
    const ob = orbit(rig, {
      anchors: 4,
      seconds: set.seconds || 20,
      dwell: set.dwell === undefined ? 1.5 : set.dwell,
      onFrame: upd
    });

    let fling = 0, lastY = 0;
    const down = e => {
      drag = true; fling = 0; rig.box.classList.remove('snap');
      ob.pause();
      lastX = (e.touches ? e.touches[0].clientX : e.clientX);
      lastY = (e.touches ? e.touches[0].clientY : e.clientY);
    };
    const move = e => {
      if (!drag) return;
      const x = (e.touches ? e.touches[0].clientX : e.clientX);
      const dx = (lastX - x) * .5;
      fling = dx;
      rig.setAngle(rig.angle + dx); lastX = x; upd();
      /* a rig with a pitch axis follows the vertical drag too, so it really
         does turn in every direction rather than only around */
      if (rig.setTilt) {
        const y = (e.touches ? e.touches[0].clientY : e.clientY);
        rig.setTilt(rig.tilt - (lastY - y) * .35);
        lastY = y;
      }
    };
    /* carry the flick through, then hand the turntable back to the driver */
    let resumeT = 0;
    const up = () => {
      if (!drag) return;
      drag = false;
      let v = clamp(fling, -18, 18);
      (function glide() {
        if (Math.abs(v) < .12) return handBack();
        rig.setAngle(rig.angle + v); upd();
        v *= .94;
        requestAnimationFrame(glide);
      })();
    };
    function handBack() {
      clearTimeout(resumeT);
      resumeT = setTimeout(() => {
        if (drag || (btnAuto && !btnAuto.classList.contains('on'))) return;
        ob.sync(); ob.resume();
      }, 2200);
    }
    stage.addEventListener('mousedown', down); addEventListener('mousemove', move); addEventListener('mouseup', up);
    stage.addEventListener('touchstart', down, { passive: true });
    stage.addEventListener('touchmove', move, { passive: true });
    addEventListener('touchend', up);

    const btnAuto = $('#spin-auto');
    btnAuto && btnAuto.addEventListener('click', () => {
      const willPlay = ob.paused;
      if (willPlay) { ob.sync(); ob.resume(); } else ob.pause();
      btnAuto.classList.toggle('on', willPlay);
      btnAuto.innerHTML = '<i class="fa-solid fa-' + (willPlay ? 'pause' : 'play') + '"></i>';
    });
    const btnRev = $('#spin-rev');
    btnRev && btnRev.addEventListener('click', () => ob.reverse());

    $$('#spin-chips button').forEach(b => b.addEventListener('click', () => {
      $$('#spin-chips button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      ob.pause();
      if (btnAuto) { btnAuto.classList.remove('on'); btnAuto.innerHTML = '<i class="fa-solid fa-play"></i>'; }
      rig.box.classList.add('snap');
      let target = +b.dataset.deg;
      const curA = rig.angle;
      let d = ((target - curA + 540) % 360) - 180;
      animateAngle(rig, curA, curA + d, 800, upd);
      setTimeout(() => rig.box.classList.remove('snap'), 900);
    }));

    $$('#spin-swatches .swatch').forEach((s, i) => s.addEventListener('click', () => {
      if (rig.isPhoto || !colorways[i]) return;
      $$('#spin-swatches .swatch').forEach(x => x.classList.remove('on'));
      s.classList.add('on'); colorIdx = i;
      paint(rig.el, colorways[i].colors);
      const cwName = $('#spin-cw-name');
      if (cwName) cwName.textContent = colorways[i].name;
    }));

    const btnAdd = $('#spin-add');
    btnAdd && btnAdd.addEventListener('click', function () {
      this.classList.remove('bump'); void this.offsetWidth; this.classList.add('bump');
      addToCart(set.product, 42);
    });
  }

  /* ---------------------------------------------------------
     11. BURGER DRAWER (hosts the 2-tab menu)
     --------------------------------------------------------- */
  function initMenu() {
    const b = $('#burger'), m = $('#menu'), bg = $('#menu-bg');
    if (!b || !m) return;
    const open = () => { b.classList.add('on'); m.classList.add('on'); bg.classList.add('on'); document.body.classList.add('is-locked'); };
    const close = () => { b.classList.remove('on'); m.classList.remove('on'); bg.classList.remove('on'); document.body.classList.remove('is-locked'); };
    b.addEventListener('click', () => m.classList.contains('on') ? close() : open());
    bg.addEventListener('click', close);
    $('#menu-close') && $('#menu-close').addEventListener('click', close);
    $$('#menu a[href^="#"], #menu .tab').forEach(el => el.addEventListener('click', () => setTimeout(close, 200)));
    CFG.closeMenu = close;

    /* sub-menus from the Shopify link list expand in place */
    $$('.menu-link--parent', m).forEach(btn => {
      const sub = btn.nextElementSibling;
      if (!sub) return;
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        sub.style.maxHeight = open ? null : sub.scrollHeight + 'px';
      });
    });
  }

  /* ---------------------------------------------------------
     12. FIT FINDER — reduces returns, boosts conversion
     --------------------------------------------------------- */
  const BRAND_OFFSET = { nike: .5, jordan: .5, adidas: 0, puma: 0, newbalance: -.5, asics: -.5, converse: 1, other: 0 };
  const BRAND_NOTE = {
    nike: 'Nike runs slightly narrow — we added half a size.',
    jordan: 'Jordan silhouettes run snug through the toe box — half a size up.',
    adidas: 'Adidas is true to size for most feet.',
    puma: 'Puma is true to size for most feet.',
    newbalance: 'New Balance runs generous — we took half a size off.',
    asics: 'ASICS runs generous in the forefoot — half a size down.',
    converse: 'Converse runs a full size large — size down.',
    other: 'We kept your usual size as the baseline.'
  };
  function initFit() {
    const go = $('#fit-go'); if (!go) return;
    let width = 'regular';
    $$('#fit-width .chip').forEach(c => c.addEventListener('click', () => {
      $$('#fit-width .chip').forEach(x => x.classList.remove('on'));
      c.classList.add('on'); width = c.dataset.w;
    }));
    go.addEventListener('click', () => {
      const brand = $('#fit-brand').value;
      const base = parseFloat($('#fit-size').value);
      const wAdj = width === 'wide' ? .5 : width === 'narrow' ? -.5 : 0;
      const rec = Math.round((base + (BRAND_OFFSET[brand] || 0) + wAdj) * 2) / 2;
      const box = $('#fit-result');
      $('#fit-size-out').textContent = 'EU ' + rec;
      $('#fit-note').textContent = BRAND_NOTE[brand] +
        (wAdj > 0 ? ' Wide feet get another half size of room.' :
         wAdj < 0 ? ' Narrow feet sit better half a size down.' : '') +
        ' 94% of customers with your profile kept this size.';
      box.classList.add('on');
      toast('Your size is ready', 'We recommend EU ' + rec, 'fa-ruler');
    });
  }

  /* ---------------------------------------------------------
     13. AUTHENTICITY VERIFIER — the trust hook
     --------------------------------------------------------- */
  const DEMO_PASSPORTS = {
    'HS-2026-A19X': ['Air Vortex 90 “Crimson Black”', 'EU 42 · Verified 12 Jul 2026 · Cairo hub'],
    'HS-2026-K44R': ['Obsidian “Carbon Edition”', 'EU 41 · Verified 03 Aug 2026 · Numbered 07/50'],
    'HS-2025-P07B': ['Street Runner “Panda”', 'EU 43 · Verified 28 Nov 2025 · Cairo hub']
  };
  function initVerify() {
    const go = $('#verify-go'), inp = $('#verify-input'), out = $('#verify-out');
    if (!go || !inp || !out) return;
    /* Shopify sections publish real passports on window.HYPESOLE.passports */
    const book = (CFG.passports && Object.keys(CFG.passports).length) ? CFG.passports : DEMO_PASSPORTS;
    function run() {
      const v = inp.value.trim().toUpperCase();
      if (!v) return;
      const hit = book[v];
      out.className = 'verify-out on ' + (hit ? 'ok' : 'bad');
      out.innerHTML = hit
        ? '<span class="vi"><i class="fa-solid fa-check"></i></span><div><b>Authentic — passport matched</b>' +
          '<span>' + hit[0] + '<br>' + hit[1] + '</span></div>'
        : '<span class="vi"><i class="fa-solid fa-xmark"></i></span><div><b>No passport found for this code</b>' +
          '<span>Check the serial printed inside the tongue, or contact our team.</span></div>';
    }
    go.addEventListener('click', run);
    inp.addEventListener('keydown', e => { if (e.key === 'Enter') run(); });
    $$('.hint-codes code').forEach(c => c.addEventListener('click', () => { inp.value = c.textContent; run(); }));
  }

  /* ---------------------------------------------------------
     14. FAQ ACCORDION
     --------------------------------------------------------- */
  function initFaq() {
    const items = $$('.faq-item');
    items.forEach(it => {
      const q = $('.faq-q', it), a = $('.faq-a', it);
      if (!q || !a) return;
      q.addEventListener('click', () => {
        const wasOpen = it.classList.contains('on');
        items.forEach(x => { x.classList.remove('on'); const ax = $('.faq-a', x); if (ax) ax.style.maxHeight = null; });
        if (!wasOpen) { it.classList.add('on'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  /* ---------------------------------------------------------
     15. LIVE SALE PROOF + STICKY BUY BAR
     --------------------------------------------------------- */
  const CITIES = ['Cairo', 'Alexandria', 'Giza', 'Dubai', 'Riyadh', 'Doha', 'Kuwait City', 'Amman', 'Jeddah', 'Casablanca'];
  function liveSales() {
    if (!PRODUCTS.length) return;
    const zone = $('#toast-zone'); if (!zone) return;
    (function fire() {
      setTimeout(() => {
        const p = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
        const city = CITIES[Math.floor(Math.random() * CITIES.length)];
        const mins = 2 + Math.floor(Math.random() * 26);
        const t = document.createElement('div');
        t.className = 'toast toast--buy';
        t.innerHTML = '<span class="tsvg"></span><div><b>Someone in ' + city + ' just bought</b>' +
          '<small>' + p.name + '  ·  ' + mins + ' min ago</small></div>';
        $('.tsvg', t).appendChild(paint(svgOf('sk-lat'), p.colors));
        zone.appendChild(t);
        setTimeout(() => { t.classList.add('out'); setTimeout(() => t.remove(), 400); }, 4600);
        fire();
      }, 11000 + Math.random() * 15000);
    })();
  }
  function initSticky() {
    const bar = $('#sticky-bar'); if (!bar || !PRODUCTS.length) return;
    const p = PRODUCTS[0];
    $('#sb-name').textContent = p.name;
    $('#sb-price').textContent = money(p.price);
    $('#sb-add').addEventListener('click', () => addToCart(p, 42));
    addEventListener('scroll', () => {
      const nearEnd = scrollY + innerHeight > document.documentElement.scrollHeight - 420;
      bar.classList.toggle('on', scrollY > 720 && !nearEnd);
    }, { passive: true });
  }

  /* ---------------------------------------------------------
     16. WIRING
     --------------------------------------------------------- */
  /* fills static decorative slots: data-sk="templateId|colourwayKey" */
  function fillStatic() {
    $$('[data-sk]').forEach(el => {
      const parts = el.dataset.sk.split('|');
      const cw = (CFG.colorways || {})[parts[1]] || null;
      el.appendChild(paint(svgOf(parts[0]), cw));
    });
  }

  /* ---------------------------------------------------------
     16. PRODUCT RAIL — drag, arrows, and a slow drift
     --------------------------------------------------------- */
  function initRails() {
    const reduced = matchMedia('(prefers-reduced-motion:reduce)').matches;
    $$('[data-rail]').forEach(rail => {
      const track = $('.rail-track', rail);
      if (!track) return;
      const head = rail.closest('section');
      const prev = head && $('[data-rail-prev]', head);
      const next = head && $('[data-rail-next]', head);
      const step = () => rail.clientWidth * .7;
      prev && prev.addEventListener('click', () => rail.scrollBy({ left: RTL ? step() : -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => rail.scrollBy({ left: RTL ? -step() : step(), behavior: 'smooth' }));

      /* pointer drag — the rail is a normal scroller, so this just maps the
         drag distance onto scrollLeft and lets native momentum finish it */
      let down = false, startX = 0, startScroll = 0, moved = 0;
      rail.addEventListener('mousedown', e => {
        down = true; moved = 0;
        startX = e.clientX; startScroll = rail.scrollLeft;
        rail.classList.add('is-dragging');
      });
      addEventListener('mousemove', e => {
        if (!down) return;
        const dx = e.clientX - startX;
        moved = Math.abs(dx);
        rail.scrollLeft = startScroll - dx;
      });
      addEventListener('mouseup', () => {
        if (!down) return;
        down = false;
        rail.classList.remove('is-dragging');
      });
      /* a drag that ends on a card must not also count as a click on it */
      rail.addEventListener('click', e => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);

      if (rail.dataset.autoscroll !== '1' || reduced) return;
      const speed = (Number(rail.dataset.speed) || 4) * .12;
      let paused = false, dir = RTL ? -1 : 1;
      rail.addEventListener('mouseenter', () => { paused = true; });
      rail.addEventListener('mouseleave', () => { paused = false; });
      rail.addEventListener('touchstart', () => { paused = true; }, { passive: true });
      rail.addEventListener('focusin', () => { paused = true; });
      (function drift() {
        requestAnimationFrame(drift);
        if (paused || down) return;
        const max = track.scrollWidth - rail.clientWidth;
        if (max <= 0) return;
        const at = Math.abs(rail.scrollLeft);
        /* bounce instead of snapping back — a jump reads as a broken widget */
        if (at >= max - 1) dir = RTL ? 1 : -1;
        else if (at <= 1) dir = RTL ? -1 : 1;
        rail.scrollLeft += speed * dir;
      })();
    });
  }

  /* ---------------------------------------------------------
     17. LOOKBOOK PINS — hover on desktop, tap on touch
     --------------------------------------------------------- */
  function initPins() {
    const pins = $$('.pin');
    if (!pins.length) return;
    pins.forEach(pin => {
      const dot = $('.pin-dot', pin);
      dot && dot.addEventListener('click', e => {
        e.stopPropagation();
        const open = pin.classList.contains('on');
        pins.forEach(p => p.classList.remove('on'));
        if (!open) pin.classList.add('on');
      });
    });
    document.addEventListener('click', () => pins.forEach(p => p.classList.remove('on')));
  }

  /* ---------------------------------------------------------
     18. DEAL OF THE DAY — swap to the closing message at zero
     --------------------------------------------------------- */
  function initFlash() {
    const flashes = $$('[data-flash]');
    if (!flashes.length) return;
    const check = () => flashes.forEach(f => {
      const t = Date.parse(f.dataset.deadlineIso);
      f.classList.toggle('is-over', !isNaN(t) && t <= Date.now());
    });
    check();
    setInterval(check, 1000);
  }

  /* ---------------------------------------------------------
     19. SCROLL STORY — the centred step drives the artwork
     --------------------------------------------------------- */
  function initScrollStory() {
    $$('[data-scrollstory]').forEach(root => {
      const steps = $$('[data-ss-step]', root);
      const art = $('[data-ss-art]', root);
      const idx = $('[data-ss-index]', root);
      if (!steps.length || !art) return;

      let active = -1;
      const paintStep = i => {
        if (i === active) return;
        active = i;
        steps.forEach((s, k) => s.classList.toggle('on', k === i));
        if (idx) idx.textContent = String(i + 1).padStart(2, '0');
        const cw = (CFG.colorways || {})[steps[i].dataset.colorway];
        if (!cw) return;
        art.classList.add('swap');
        setTimeout(() => { paint(art, cw); art.classList.remove('swap'); }, 220);
      };

      /* the band across the middle of the viewport decides which step is live */
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) paintStep(steps.indexOf(e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      steps.forEach(s => io.observe(s));
      paintStep(0);
    });
  }

  /* ---------------------------------------------------------
     20. MANIFESTO — reveal the statement word by word
     --------------------------------------------------------- */
  function initManifesto() {
    $$('[data-manifesto]').forEach(line => {
      /* Split on text nodes only, so the accent <span>s survive intact. */
      const walk = node => {
        [...node.childNodes].forEach(n => {
          if (n.nodeType === 3) {
            const frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(part => {
              if (!part.trim()) { frag.appendChild(document.createTextNode(part)); return; }
              const w = document.createElement('span');
              w.className = 'mf-word';
              w.textContent = part;
              frag.appendChild(w);
            });
            n.replaceWith(frag);
          } else if (n.nodeType === 1) {
            walk(n);
          }
        });
      };
      walk(line);

      const words = $$('.mf-word', line);
      words.forEach((w, i) => { w.style.transitionDelay = (i * 42) + 'ms'; });

      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(e => {
          if (!e.isIntersecting) return;
          line.classList.add('in');
          obs.disconnect();
        });
      }, { threshold: .25 });
      io.observe(line);
    });
  }

  function boot() {
    fillStatic();
    initManifesto();
    initMenu();
    initHero();
    initTabs();
    initProductTabs();
    initRails();
    initPins();
    initFlash();
    initScrollStory();
    init360();
    initFit();
    initVerify();
    initFaq();
    initSticky();
    if (PRODUCTS.length) renderCart();
    observeReveals();
    liveSales();

    /* Always-on: chrome that behaves the same in both modes */
    $('#close-cart') && $('#close-cart').addEventListener('click', closeCart);
    $('#cart-bg') && $('#cart-bg').addEventListener('click', closeCart);
    $('#qv-close') && $('#qv-close').addEventListener('click', closeQuick);
    $('#qv-bg') && $('#qv-bg').addEventListener('click', closeQuick);
    $('#qv-zoom') && $('#qv-zoom').addEventListener('click', function () { this.classList.toggle('zoomed'); });
    $('#verify-form') && $('#verify-form').addEventListener('submit', e => e.preventDefault());

    /* Prototype-only wiring. On Shopify the bridge owns the cart, Quick View
       and checkout, so these must not double-fire. */
    if (PRODUCTS.length) {
      $('#open-cart') && $('#open-cart').addEventListener('click', openCart);
      $('#qv-add') && $('#qv-add').addEventListener('click', function () {
        if (!qvState.size) return toast('Pick a size first', 'Select your EU size to continue', 'fa-triangle-exclamation');
        this.classList.remove('bump'); void this.offsetWidth; this.classList.add('bump');
        addToCart(qvState.p, qvState.size); closeQuick(); openCart();
      });
      $('#qv-buy') && $('#qv-buy').addEventListener('click', () => {
        if (!qvState.size) return toast('Pick a size first', 'Select your EU size to continue', 'fa-triangle-exclamation');
        closeQuick(); buyNow(qvState.p, qvState.size);
      });
      $('#cart-checkout') && $('#cart-checkout').addEventListener('click', () => {
        if (!CART.length) return toast('Cart is empty', 'Add a pair before checking out', 'fa-triangle-exclamation');
        closeCart(); buyNow(CART[0].p, CART[0].size);
      });
      $$('.cta-form').forEach(f => f.addEventListener('submit', e => {
        e.preventDefault(); f.reset();
        toast('Welcome to the club', 'Your 10% first-order code is on its way', 'fa-ticket');
      }));
    }
    addEventListener('keydown', e => {
      if (e.key === 'Escape') { closeQuick(); closeCart(); CFG.closeMenu && CFG.closeMenu(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
